export const locale = {
    lang: 'cs',
    data: {
        NAV: {
            DASHBOARD: 'Nástěnka',
            CLIENTS: 'Klienti',
            NEW_CLIENT: 'Nový klient',
            PRE_ANALYSIS_CLIENT: 'Předanalýza',
            IMPORT_CLIENT: 'Importovat klienta',
            INVESTMENT_GARANT: 'Investiční garant',
            INVESTMENT_GARANT_WAITING: 'Čekající',
            INVESTMENT_GARANT_DONE: 'Hotové',
            INVESTMENT_GARANT_AUTOMATIC: 'Automatické',
            NEW_CLIENT_LEADSHOP: 'Klient z leadshopu',
            CONTRACTS: {
                CONTRACTS: 'Smlouvy',
                LIST: 'Seznam',
                NEW: 'Vytvořit',
            },
            ADVISORS: {
                ADVISORS: 'Poradci',
                LIST: 'Seznam',
                TREE: 'Strom',
                MANUFACTORY: 'Manufaktura',
                NEW: 'Vytvořit',
            },
            REPORTS: {
                TITLE: 'Reporty',
                ADVISORS: 'Poradenské',
            },
        }
    }
};
